import Button from 'components/Button'
import { toggleShowHelpBar } from 'features/contextual_help/contextualHelpSlice'
import { useAsync } from 'hooks'
import useRoute from 'hooks/useRoute'
import React, { useState } from 'react'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import styled, { css } from 'styled-components'
import { _ } from 'utils'
import { getContextualHelps, getUrlByContext } from 'utils/cms'

const S = {
    HelpIcon: styled.div<{ showTooltip: boolean }>`
        padding: 8px 0;
        ${({ showTooltip }) => showTooltip && css`
            &:before {
                content: '';
                position: fixed;
                top: 0;
                left: 0;
                width: 100vw;
                height: 100vh;
                background-color: rgba(0, 0, 0, 0.5);
                z-index: 9999;
            }
        `}
    `,
    Icon: styled.div`
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10000;
        background-color: white;
        box-shadow: 0 0 10px white,
                    0 0 18px white,
                    0 0 20px white,
                    0 0 25px white,
                    0 0 30px white;
        border-radius: 50%;
        cursor: pointer;
    `,
}

const HelpIcon = () => {
    const hasShownHelpTooltip = localStorage.getItem('hasShownHelpTooltip')
    const [showTooltip, setShowTooltip] = useState(hasShownHelpTooltip !== 'true')
    const currentRoute = useRoute()
    const context = currentRoute?.context
    const { value } = useAsync(getContextualHelps)
    const contextHelpUrl = getUrlByContext(value?.data, context)
    const dispatch = useDispatch()
    const hideTooltip = () => {
        setShowTooltip(false)
        localStorage.setItem('hasShownHelpTooltip', 'true')
    }

    const popover = (
        <Popover id="popover-basic">
            <Popover.Title as="h3">{_('help_tooltip.title')}</Popover.Title>
            <Popover.Content>
                <p>{_('help_tooltip.description')}</p>
                <Button
                    variant="secondary"
                    size="sm"
                    onClick={hideTooltip}
                    className="d-block ml-auto"
                >
                    {_('button.i_understand')}
                </Button>
            </Popover.Content>
        </Popover>
    )

    return contextHelpUrl ? (
        <OverlayTrigger show={showTooltip} placement="bottom" overlay={popover}>
            <S.HelpIcon showTooltip={showTooltip}>
                <S.Icon onClick={() => dispatch(toggleShowHelpBar(contextHelpUrl))} className="ml-2">
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d={`
                                M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10
                                0ZM11 17H9V15H11V17ZM13.07 9.25L12.17 10.17C11.45 10.9 11 11.5 11 13H9V12.5C9 11.4 9.45 10.4 10.17
                                9.67L11.41 8.41C11.78 8.05 12 7.55 12 7C12 5.9 11.1 5 10 5C8.9 5 8 5.9 8 7H6C6 4.79 7.79 3 10
                                3C12.21 3 14 4.79 14 7C14 7.88 13.64 8.68 13.07 9.25Z
                            `}
                            fill="#3068F4"
                        />
                    </svg>
                </S.Icon>
            </S.HelpIcon>
        </OverlayTrigger>
    ) : (
        <div />
    )
}

export default HelpIcon
